import {Expired, MissingKeyAlias, PGPKeyType, PGPSearchField} from "components/src/api/admin/generated";
import {useTranslationWithOverride} from "components/src/hook/UseTranslationWithOverride";
import {Utils} from "components/src/utils/Utils";
import {Dispatch, SetStateAction} from "react";
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';

interface PGPKeyFilterProps {
    expired? : Expired
    setExpired?: Dispatch<SetStateAction<Expired>>
    missingKeyAlias? : MissingKeyAlias
    setMissingKeyAlias? : Dispatch<SetStateAction<MissingKeyAlias>>
    keyType? : PGPKeyType
    setKeyType? : Dispatch<SetStateAction<PGPKeyType>>
    searchField? : PGPSearchField
    setSearchField : Dispatch<SetStateAction<PGPSearchField>>
    searchValue? : string
    setSearchValue? : Dispatch<SetStateAction<string | undefined>>
    activeSearchValue? : string
    setActiveSearchValue? : Dispatch<SetStateAction<string | undefined>>
}

export const PGPKeyFilter = ({expired, setExpired, missingKeyAlias, setMissingKeyAlias, keyType, setKeyType,
                                 searchField, setSearchField, searchValue, setSearchValue, activeSearchValue,
                                 setActiveSearchValue} : PGPKeyFilterProps) =>
{
    /**
     * i18next translation hook
     */
    const {t} = useTranslationWithOverride();

    return (
        <>
            {setExpired !== undefined &&
            <Col xs="auto">
                <Form.Select
                             aria-label={t("pgp-key-ring.expired")}
                             value={expired}
                             onChange={(e) => setExpired(Utils.stringToEnum(Expired, e.target.value as Expired))}>
                    <option value="MATCH_ALL">{t("pgp-key-filter.match-all")}</option>
                    <option value="MATCH_UNEXPIRED_ONLY">{t("pgp-key-filter.match-unexpired-only")}</option>
                    <option value="MATCH_EXPIRED_ONLY">{t("pgp-key-filter.match-expired-only")}</option>
                </Form.Select>
            </Col>}

            {setMissingKeyAlias !== undefined &&
                <Col xs="auto">
                    <Form.Select
                                 aria-label={t("pgp-key-filter.missing-key-alias")}
                                 value={missingKeyAlias}
                                 onChange={(e) => setMissingKeyAlias(Utils.stringToEnum(MissingKeyAlias, e.target.value as MissingKeyAlias))}>
                        <option value="ALLOWED">{t("pgp-key-filter.all")}</option>
                        <option value="NOT_ALLOWED">{t("pgp-key-filter.private-key")}</option>
                    </Form.Select>
                </Col>}

            {setKeyType !== undefined &&
                <Col xs="auto">
                    <Form.Select
                                 aria-label={t("pgp-key-filter.key-type")}
                                 value={keyType}
                                 onChange={(e) => setKeyType(Utils.stringToEnum(PGPKeyType, e.target.value as PGPKeyType))}>
                        <option value="MASTER_KEY">{t("pgp-key-filter.master-keys")}</option>
                        <option value="SUB_KEY">{t("pgp-key-filter.sub-keys")}</option>
                        <option value="ALL">{t("pgp-key-filter.all")}</option>
                    </Form.Select>
                </Col>}

            {setSearchValue !== undefined && setActiveSearchValue !== undefined &&
            <Col xs="auto">
                <InputGroup>
                    <Form.Select
                                 aria-label={t("pgp-key-filter.search-selection")}
                                 value={searchField}
                                 onChange={(e) => setSearchField(Utils.stringToEnum(PGPSearchField, e.target.value as PGPSearchField))}>
                        <option value="EMAIL">{t("pgp-key-filter.email")}</option>
                        <option value="USER_ID">{t("pgp-key-filter.user-id")}</option>
                        <option value="KEY_ID">{t("pgp-key-filter.key-id")}</option>
                        <option value="FINGERPRINT">{t("pgp-key-filter.fingerprint")}</option>
                    </Form.Select>
                    <Form.Control
                                  aria-label={t("pgp-key-filter.search-value")}
                                  type="search"
                                  placeholder={t("pgp-key-filter.search")}
                                  value={searchValue}
                                  onChange={e => setSearchValue(e.target.value)}
                    />
                    <Button
                            variant="primary"
                            onClick={() => setActiveSearchValue(searchValue)}
                            disabled={activeSearchValue === searchValue}>
                        {t("pgp-key-filter.search")}
                    </Button>
                </InputGroup>
            </Col>}
        </>
    )
}
